import React, { Component } from "react";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: true
    };
  }
  componentDidMount() {
    // setInterval(() => {
    //   this.setState({ name: !this.state.name });
    // }, 4000);
  }
  renderHeader() {
    if (this.state.name) {
      return <h3 className="myname slide-left">Edmond O'Connell</h3>;
    } else {
      return <h3 className="myname">Front End Developer</h3>;
    }
  }
  render() {
    return <div className="navbar-fixed-top">{this.renderHeader()}</div>;
  }
}

export { Header };
